module.exports = __webpack_public_path__ + "static/media/masthead-the-kimberley-echo.0d948a7f.png";